import { Controller } from "@hotwired/stimulus"

// Hides the dev-only mirror banner when dismissed and remembers the dismissal per source via
// localStorage, so it stays hidden across page loads. Revisit: dismissal persists until localStorage
// is cleared; a different source (a new dump) shows its own banner again.
export default class extends Controller {
  static values = { key: String }

  connect() {
    if (localStorage.getItem(this.storageKey) === "dismissed") {
      this.element.remove()
    }
  }

  dismiss() {
    localStorage.setItem(this.storageKey, "dismissed")
    this.element.remove()
  }

  get storageKey() {
    return `mirror-banner-dismissed:${this.keyValue}`
  }
}
